export default __webpack_public_path__ + "static/media/eqixs.0fd6bac3.jpg";